module.exports = __webpack_public_path__ + "img/2@2x.6d49ca98.png";